import type { ReactNode } from "react"
import { ApiError } from "../api/client.ts"
import { useT } from "../i18n/index.tsx"
import { Icon, type IconName } from "./icons.tsx"

export type AlertTone = "info" | "ok" | "warn" | "danger"

const TONE_ICON: Record<AlertTone, IconName> = {
  info: "info",
  ok: "check",
  warn: "alert",
  danger: "alert",
}

export function Alert({
  tone = "info",
  title,
  children,
  actions,
}: {
  tone?: AlertTone
  title?: ReactNode
  children?: ReactNode
  actions?: ReactNode
}) {
  return (
    <div className={`alert alert--${tone}`} role={tone === "danger" ? "alert" : "status"}>
      <Icon name={TONE_ICON[tone]} size={18} className="alert__icon" />
      <div className="alert__text">
        {title ? <strong className="alert__title">{title}</strong> : null}
        {children ? <div>{children}</div> : null}
      </div>
      {actions ? <div className="alert__actions">{actions}</div> : null}
    </div>
  )
}

/** 서버가 보낸 오류 코드를 사전에서 찾아 보여 준다. 서버는 문장을 만들지 않는다. */
export function ErrorNote({ error }: { error: unknown }) {
  const t = useT()
  if (!error) return null
  const code = error instanceof ApiError ? error.code : "INTERNAL"
  return <Alert tone="danger">{t(`error.${code}`)}</Alert>
}
